export default {
    checkinOnsite: 'ลงชื่อเข้างานนอกสถานที่',
    yourLocation: 'ตำแหน่งของคุณ',
    cancel: 'ยกเลิก',
    submit: 'ส่ง',
    edit: 'แก้ไข',
    save: 'บันทึก',
    searching: 'ค้นหาตำเเหน่งของคุณ ...',
    fieldRequired: 'กรุณากรอกข้อมูล',
    msgNoInquiry: 'คุณไม่มีคำขอออกนอกสถานที่ในวันนี้',
    networkError: 'ระบบ Network เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่ฝ่าย Support',
    msgSuccess: 'บันทึกสำเร็จ',
    msgGPSError: 'กรุณาเปิด GPS เพื่อระบุตำแหน่งของคุณ',
    getLocationError: 'เกิดข้อผิดพลาดตำเเหน่งไม่ถูกต้อง',
    cannotGetLineId: 'เกิดข้อผิดพลาด'
}
